/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
import ScrollTo from '../site/scrollTo';

'use strict';
const scrollToTable = {
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		setTimeout(function(){$('.page-loader__container').addClass('turnoff-loader');}, 2000);
		if (window.location.href.indexOf('?term=')>-1 && $('filters-product') !== 0) {
			ScrollTo.scrollToTarget($('.filters-search'));
			setTimeout(function(){$('.page-loader__container').addClass('turnoff-loader');}, 2000);
		}
	},
};

export default scrollToTable;
